import React, { Component } from 'react'

import { FormattedMessage } from 'react-intl'

import { LOCALE_PREFIX } from './constants'

import './style.scss'

export default class PaymentIndexTooltip extends Component {
    render() {
        return (
            <div className={'payment-index-tooltip'}>
                <FormattedMessage
                    id={`${LOCALE_PREFIX}.paymentIndexTooltipMain`}
                    values={{ strong: (chunks) => <strong>{chunks}</strong>, br: <br /> }}
                />
                <div className={'payment-index-tooltip-container'}>
                    <div>
                        <div className={'payment-index-tooltip-row'}>
                            <div style={{ color: '#7BA02D' }} className={'payment-code'}>
                                -30
                            </div>
                            <FormattedMessage id={`${LOCALE_PREFIX}.clutch`} />
                            <div style={{ color: '#7BA02D' }} className={'payment-code'}>
                                0
                            </div>
                            <FormattedMessage id={`${LOCALE_PREFIX}.paymentText1`} />
                        </div>
                        <div className={'payment-index-tooltip-row'}>
                            <div style={{ color: '#A7B71E' }} className={'payment-code'}>
                                0
                            </div>
                            <FormattedMessage id={`${LOCALE_PREFIX}.clutch`} />
                            <div style={{ color: '#A7B71E' }} className={'payment-code'}>
                                4
                            </div>
                            <FormattedMessage id={`${LOCALE_PREFIX}.paymentText2`} />
                        </div>
                        <div className={'payment-index-tooltip-row'}>
                            <div style={{ color: '#D3CF0F' }} className={'payment-code'}>
                                4
                            </div>
                            <FormattedMessage id={`${LOCALE_PREFIX}.clutch`} />
                            <div style={{ color: '#D3CF0F' }} className={'payment-code'}>
                                10
                            </div>
                            <FormattedMessage id={`${LOCALE_PREFIX}.paymentText3`} />
                        </div>
                    </div>
                    <div className={'payment-icon'}>
                        <div className={'payment-icon-green'} />
                        <FormattedMessage id={`${LOCALE_PREFIX}.firstPaymentIconText`} />
                    </div>
                </div>
                <div className={'payment-index-tooltip-container'}>
                    <div>
                        <div className={'payment-index-tooltip-row'}>
                            <div style={{ color: '#FFE600' }} className={'payment-code'}>
                                11
                            </div>
                            <FormattedMessage id={`${LOCALE_PREFIX}.clutch`} />
                            <div style={{ color: '#FFE600' }} className={'payment-code'}>
                                20
                            </div>
                            <FormattedMessage id={`${LOCALE_PREFIX}.paymentText4`} />
                        </div>
                        <div className={'payment-index-tooltip-row'}>
                            <div style={{ color: '#F7AD00' }} className={'payment-code'}>
                                21
                            </div>
                            <FormattedMessage id={`${LOCALE_PREFIX}.clutch`} />
                            <div style={{ color: '#F7AD00' }} className={'payment-code'}>
                                30
                            </div>
                            <FormattedMessage id={`${LOCALE_PREFIX}.paymentText5`} />
                        </div>
                        <div className={'payment-index-tooltip-row'}>
                            <div style={{ color: '#EF7300' }} className={'payment-code'}>
                                31
                            </div>
                            <FormattedMessage id={`${LOCALE_PREFIX}.clutch`} />
                            <div style={{ color: '#EF7300' }} className={'payment-code'}>
                                60
                            </div>
                            <FormattedMessage id={`${LOCALE_PREFIX}.paymentText6`} />
                        </div>
                    </div>
                    <div className={'payment-icon'}>
                        <div className={'payment-icon-orange'} />
                        <FormattedMessage id={`${LOCALE_PREFIX}.secondPaymentIconText`} />
                    </div>
                </div>
                <div className={'payment-index-tooltip-container'}>
                    <div>
                        <div className={'payment-index-tooltip-row'}>
                            <div style={{ color: '#E83A00' }} className={'payment-code'}>
                                61
                            </div>
                            <FormattedMessage id={`${LOCALE_PREFIX}.clutch`} />
                            <div style={{ color: '#E83A00' }} className={'payment-code'}>
                                90
                            </div>
                            <FormattedMessage id={`${LOCALE_PREFIX}.paymentText7`} />
                        </div>
                        <div className={'payment-index-tooltip-row'}>
                            <div style={{ color: '#E00000' }} className={'payment-code'}>
                                91
                            </div>
                            <FormattedMessage id={`${LOCALE_PREFIX}.clutch`} />
                            <div style={{ color: '#E00000' }} className={'payment-code'}>
                                120
                            </div>
                            <FormattedMessage id={`${LOCALE_PREFIX}.paymentText8`} />
                        </div>
                        <div className={'payment-index-tooltip-row'}>
                            <div style={{ color: '#790013' }} className={'payment-code'}>
                                121
                            </div>
                            <FormattedMessage id={`${LOCALE_PREFIX}.clutch`} />
                            <div style={{ color: '#790013' }} className={'payment-code'}>
                                180
                            </div>
                            <FormattedMessage id={`${LOCALE_PREFIX}.paymentText9`} />
                        </div>
                    </div>
                    <div className={'payment-icon'}>
                        <div className={'payment-icon-red'} />
                        <FormattedMessage id={`${LOCALE_PREFIX}.thirdPaymentIconText`} />
                    </div>
                </div>
                <br />
                <div className={'payment-footer-text'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.paymentFooterText1`} />
                    <FormattedMessage id={`${LOCALE_PREFIX}.paymentFooterText2`} />
                </div>
                <br />
                <div>
                    <FormattedMessage id={`${LOCALE_PREFIX}.paymentFooterText3`} />
                </div>
                <br />
                <div>
                    <FormattedMessage id={`${LOCALE_PREFIX}.paymentFooterText4`} />
                </div>
            </div>
        )
    }
}
